import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

/**
 * @addedBy
 * @description sui message controller
 * @dateCreated 8 Nov 2023
 */
@Component({
  selector: 'esl-message-toast',
  templateUrl: './message-toast.component.html',
  styleUrls: ['./message-toast.component.scss'],
})
export class MessageToastComponent implements OnInit, OnChanges {
  @Input() messageType: 'success' | 'warning' | 'error' | 'info' = 'error';
  @Input() message: any = '';
  @Input() close: boolean = true;
  @Output() messageChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() useJson: boolean = true;
  @Input() duration: number = 10000;
  timeout: any;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.message) {
      if (changes.message.currentValue !== changes.message.previousValue) {
        this.close ? this.removeMessage() : '';
      }
    }
  }

  // Remove message after 5 seconds
  removeMessage() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.message = '';
      this.messageChange.emit(this.message);
    }, this.duration);
  }
}
